import { render } from "./TimeStats.vue?vue&type=template&id=fb1d97c4&scoped=true"
import script from "./TimeStats.vue?vue&type=script&lang=js"
export * from "./TimeStats.vue?vue&type=script&lang=js"

import "./TimeStats.vue?vue&type=style&index=0&id=fb1d97c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1d97c4"]])

export default __exports__